import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addtowishinpostbyid,
  addtowishinrecentpost,
  getPostListings,
  getPosts,
  getSimilarPostListings,
} from "../../../../../redux/posts/action";
import { useStateContext } from "../../../../../Context/StateContext";
import getTimeDifference from "../../../../Common/TimeDifference";
import {
  formatNumberWithCommas,
  getMemberSince,
} from "../../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { getPostType, getSortNamePostType, decodeHtml } from "../../../../../assests/extention/commonfunction";

export default function SimilarPosts({ posts }) {
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const { state } = useStateContext();
  const { selectedTypes } = state;
  const dispatch = useDispatch();
  const getpostlist = useSelector(({ posts: { getsimilarpostlist } }) => getsimilarpostlist);

  let type;
  useEffect(() => {
    if (Array.isArray(selectedTypes)) {
      type = selectedTypes.filter((item, index) => {
        return item;
      });
      type.reverse();
    }
  }, [state]);

  useEffect(() => {
    if (posts?.type && posts?.category_id && posts?.id) {
      dispatch(getSimilarPostListings(posts?.type, posts?.category_id, posts?.id));
    }
  }, [posts]);

  const navigatetopost = (item) => {
    switch (String(item.type)) {
      case "1":
        navigate(`/${lan}/projectdetails/${item.id}`);
        break;
      case "2":
        navigate(`/${lan}/contestdetails/${item.id}`);
        break;
      case "3":
        navigate(`/${lan}/jobdetails/${item.id}`);
        break;
      default:
        navigate(`/${lan}/projectdetails/no_id`);
    }
  };

  const addtowishlist11 = (id) => {
    dispatch(addtowishinrecentpost(id));
  };

  return (
    <>
      {Array.isArray(getpostlist) && getpostlist?.length > 0 &&
        <div className="col-md-12 similar-products">
          <div className="similar-head">
            <h6>Similar posts</h6> 
            <button
              className="btn view-all"
              onClick={() => navigate(`/${laung ?? "en"}/searchall?type=${posts?.type}`, { state: { similar_category_wise: posts?.category_id }  })}
            >
              View all
            </button>
          </div>
          <div>
            {Array.isArray(getpostlist) &&
              getpostlist.map(
                (item, index) =>
                  index < 3 && (
                    <div className="filter-detail" key={index}>
                      <div
                        onClick={() => {
                          navigatetopost(item);
                        }}
                      >
                        <h5>
                          {decodeHtml(item.title)} {getSortNamePostType(item.type)}
                        </h5>
                        <div className="dollar-sec">
                          <p>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                              alt=""
                            />
                            {item?.type == 2 ? "Prize" : "Budget"}: $
                            {formatNumberWithCommas(item.price)}
                          </p>
                          {item?.type == 3 ? (
                            <p>
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                                alt=""
                              />
                              Job type: {" "}
                              {item?.work_location == 1
                                ? "Virtual"
                                : item?.work_location == 2
                                  ? "Physical"
                                  : ""}
                            </p>
                          ) : (
                            <p>
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                                alt=""
                              />
                              Deadline:&nbsp;
                              {item?.type == 2 ? (
                                <> {getMemberSince(item?.last_date)} </>
                              ) : (
                                <>
                                  {item?.duration}&nbsp;
                                  {item?.duration_type == 2
                                    ? "Days"
                                    : item?.duration_type == 3
                                      ? "Weeks"
                                      : item?.duration_type == 4
                                        ? "Months"
                                        : ""}
                                </>
                              )}
                            </p>
                          )}
                          <p>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                              alt=""
                            />
                            Posted:{getTimeDifference(item.created_on)}
                          </p>
                        </div>
                        <CustomReactQuillDescription value={item.description}
                          displyreadorless={false} />
                        <div className="photoshop">
                          {Array.isArray(item?.skills) &&
                            item?.skills.map((item1, index1) => (
                              <p key={index1}>{decodeHtml(item1.title)}</p>
                            ))}
                        </div>
                        <div className="proposal">
                          <p>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/project/proposal.svg`}
                              alt=""
                            />
                            {item?.type == 2 ? "Entries" : "Proposal"}:
                            {item.proposal_count}
                          </p>
                          {item?.type == 3 ? (
                            <p>
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                                alt=""
                              />
                              Location: {decodeHtml(item.city_name)}
                            </p>
                          ) : (
                            ""
                          )}
                          <p>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/project/payment.svg`}
                              alt=""
                            />
                            Verified Payment
                          </p>
                        </div>
                      </div>
                      <button
                        className="btn heart-btn"
                        onClick={() => {
                          item.wishlist == 1
                            ? addtowishlist11(item?.id, 1)
                            : addtowishlist11(item?.id, 1);
                        }}
                      >
                        {item.wishlist == 1 ? (
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                            alt=""
                          />
                        ) : (
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                            alt=""
                          />
                        )}
                      </button>
                    </div>
                  ),
              )}
          </div>
        </div>
      }
    </>
  );
}
